import { getLogoutApi } from "@/api/user";
import { useRouter } from "@/i18n/routing";
import { useSearchStore } from "@/stores/useSearchStore";
import { useUserInfoStore } from "@/stores/useUserInfoStore";
import { useWalletStore } from "@/stores/useWalletStore";
import { Local } from "@/utils/storage";
import dayjs from "dayjs";
import Cookies from "js-cookie";

export const useLogout = () => {
    const restGlobal = useUserInfoStore((state) => state.reset);
    const resetSearch = useSearchStore((state) => state.reset);
    const restWalletStore = useWalletStore((state) => state.reset);
    const router = useRouter();
    const logout = async () => {
        let res = await getLogoutApi();
        const isClearPromotion = dayjs().isSame(sessionStorage.getItem("isClosePromotion"), "days");
        if (res.code == 200) {
            restGlobal();
            resetSearch();
            restWalletStore();
            const keys: string[] = [];
            for (let i = 0, len = Local.length; i < len; i++) {
                const key = Local.key(i);
                keys.push(key || "");
            }
            keys.forEach((key) => {
                if (key && key.indexOf("ban") === -1) {
                    Local.removeKey(key as any);
                }
            });
            Cookies.remove("Token");
            router.replace("/login");
        }
        if (!isClearPromotion) {
            sessionStorage.clear();
        }

        return Promise.resolve(res);
    };
    return {
        logout,
    };
};
